import { atom } from 'jotai'

export const appVersionAtom = atom<undefined | string>(undefined)

/**
 * true -> enabled
 * false -> disabled
 */
export const isDevModeAtom = atom<boolean>(false)
